import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType, DurationSchema } from '../base/baseSchema.js';

export const ServiceReviewBlockConfigSchema = z.object({
  transactionType: z.string().optional(),
  submissionMode: z.string().optional(),
  payorPortal: z.string().optional(),
  patientOrder: z.string().optional(),
  patientInsuranceId: z.string().optional(),
  customPayload: z.string().optional(),
  fileReference: z.string().optional(),
  caseId: z.string().optional(),
  description: z.string().optional(),
  isTest: z.boolean().optional(),
  timeout: DurationSchema,
});

export type ServiceReviewBlockConfig = z.infer<typeof ServiceReviewBlockConfigSchema>;

export const ServiceReviewBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.ServiceReview),
  config: ServiceReviewBlockConfigSchema,
});

export type ServiceReviewBlock = z.infer<typeof ServiceReviewBlockSchema>;
